var memoTable;

function InitMemoDataTable(dateFormat) {

    /*  $(document).ready(function () {*/
    console.log("creating new table1");

    if (memoTable != null) {
        try {
            memoTable.destroy();
            memoTable = null;
        } catch (e) {

        }
    }

    memoTable = $('#memoViewList').DataTable({
        "order": [[1, "desc"]],
        pageLength: 25,
        autoWidth: false,
        "columnDefs": [
            { "width": "56px", "targets": 0 }, //Memo #
            { "width": "196px", "targets": 1 }, //State
            { "width": "256px", "targets": 2 }, //Created
            { "width": "256px", "targets": 3 }, //Due date
            { "width": "256px", "targets": 4 }, //Due date
            { "width": "128px", "targets": 5 }, //Priority
            //{ "width": "196px", "targets": 5 }, //Title
            //{ "width": "148px", "targets": 6 }, //Assigned to
            //{ "width": "128px", "targets": 7 }, //Unit
        ],
        "language": {
            "emptyTable": "There are currently no memos. Create a new memo with the button in the top right",
            "info": "Showing _START_ to _END_ of _TOTAL_ memos",
            "infoEmpty": "Showing 0 to 0 of 0 memos",
            "infoFiltered": "(filtered from _MAX_ total memos)",
            "lengthMenu": "Show _MENU_ memos"
        },
        columns: [
            {
                data: 'memoNumber',
            },
            {
                data: 'created',
                render: function (data, type) {
                    if (type === 'display') {
                        if (dateFormat == 0) {
                            return timestampToJexcelDate(data);
                        }
                        else {
                            return timestampToUsDate(data);
                        }


                    }

                    return data;
                }
            },
            {
                data: "title"
            },
            {
                data: "text"
            },
            {
                data: "author"
            },
            {
                data: 'memoNumber',
                render: function (data, type) {
                    if (type === 'display') {

                        var deleteMemoButton = '<div class="btn btn-outline-danger delete-memo-in-grid-btn" onclick="deleteMemoFromgrid(' + data + ')" style="border-radius:2px;width:64px;">Remove</div>';


                        return deleteMemoButton;
                        //return '<span class="flag ' + country + '"></span> ' + data;
                    }

                    return data;
                }
            },

        ]
    });

    $('#memoViewList tbody').on('click', 'tr', function () {
        var data = memoTable.row(this).data();
        console.log(data);

        var memoNumberParsed = -1;

        try {
            memoNumberParsed = parseInt(data.memoNumber);
        } catch (e) {

        }

        if (memoNumberParsed > 0) {
            //use to open memo
         //   DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnMemoClickedFromGrid', memoNumberParsed);
        }



    });

    $("#memoViewList tr").css('cursor', 'pointer');

    //});

    return 1;
}

function FilterMemoDataTableOnAssignedTo(assignedToName) {
    if (memoTable != null) {
        memoTable.columns(6).search(assignedToName).draw();
    }

}

function RemoveAssignedToFilterMemoDataTable(arg) {
    if (memoTable != null) {
        memoTable.columns(6).search('').draw();
    }

}

function PopulateToMemoDataTable(rows) {

    console.log("rows");
    console.log(rows);

    var memos = [];

    rows.forEach(row => memos.push({
        memoNumber: row.memoId,
        created: new Date(row.memoCreated),
        title: row.memoTitle,
        author: row.memoAuthor,
        text: row.memoText
    }));

    //  memos = memos.reverse();

    console.log("memos");
    console.log(memos);

    try {
        memoTable.rows().remove()
    } catch (e) {
        console.log(e);
    }


    try {
        memoTable.rows.add(memos);
        memoTable.draw();

    } catch (e) {
        console.log(e);
    }



    console.log("updated");
}

function ReloadMemoDataTable(row) {

    console.log("reloading table..");
    if (memoTable != null) {
        console.log("destroying table..");
        memoTable.destroy();
        setTimeout(function () {
            console.log("buuilding table..");
            InitMemoDataTable();
        }, 2000);
    }

    //  memoTable.row.add([row.memoEventMemoId, row.memoEventState, 'Edinburgh']);

    //$(document).ready(function () {
    //    //$('#example').DataTable().destroy();
    //    console.log("creating new table2");
    //   // $('#example').DataTable();

    //    //memoTable.clear();
    //    var data = memoTable.data();
    //    memoTable.draw();
    //});
}

function createPortalPageTooltip(el, text) {

    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}


function confirmSetAllActivated(allEnabled) {

    swal({
        title: "Are you sure?",
        text: "This will " + (allEnabled ? "enable" : "disable") + " the portal for all units",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-info",
        confirmButtonText: "Yes",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnAllActivatedChangedConfirmed', allEnabled);
           
        });
}

function deleteMemoFromgrid(memoId) {
 

    swal({
        title: "Are you sure?",
        text: "This will remove the clicked memo",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Yes",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDeleteMemoConfirmed', memoId);

        });
}

function reKeyPortal(portalCode) {

    swal({
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes",
        closeOnConfirm: true,
        text: "This will create a new PIN code for this unit<br><br><input id='checkbox-recreate-code' type='checkbox' name='recreatecodechk' value='newcode'> Also create a new resident code<br><br>This will make the current code and PIN unusable",
        html: true
    }, function () {

       // var checkedRecreateCode = $('#checkbox-recreate-code').val();
       // alert("checkedRecreateCode: " + checkedRecreateCode);

        var recreateCode = false;

        if ($('#checkbox-recreate-code').is(":checked"))
        {
            recreateCode = true;
        }
      
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnReKeyPortalConfirmed', portalCode, recreateCode);


    });

}

function showSendPortalInformationMessageModal(arg) {
    $('#showPortalSendInformationMessageModal').modal();
}

function InitPortalInfoResidentsTypeahead(people) {

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        var phone = people[i].receiverPhonenumber;
        var email = people[i].receiverEmail;
        if (name !== "") {
            peopleRaw.push(unit + ", " + name + ", " + email);
        }
    }

    buildTypeahead('#residentUnitPortalInfoSelect .typeahead', "people", peopleRaw);

    return true;
}

function showPortalInfoInvalidEmailAddress() {
    swal({
        title: "Invalid email address",
        text: "\nPlease enter a valid email address",
        type: "info"
    });
}

function confirmSendPortalInfo(residentUnit, residentName, emailAddress, includeCredentials) {

    var infoText = "This will send an email to " + residentName + " (" + emailAddress + ") with an attached document of how to login to the portal";

    if (includeCredentials) {
        infoText = "This will send an email to " + residentName + " (" + emailAddress + ") with an attached document of how to login to the portal including their resident code and PIN code.";
    }

    swal({
        title: "Are you sure?",
        text: infoText,
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-info",
        confirmButtonText: "Yes, send.",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnSendPortalInfoToResidentConfirmed', residentUnit, residentName, emailAddress, includeCredentials);

            $('#showPortalSendInformationMessageModal').modal('hide');
            swal("Sent.", "Document was sent to " + residentName + " (" + emailAddress + ")", "success");


        });
}